import { render, staticRenderFns } from "./AutorizacionComercioAsociadoRespuesta.vue?vue&type=template&id=56f0310a&scoped=true&"
import script from "./AutorizacionComercioAsociadoRespuesta.vue?vue&type=script&lang=js&"
export * from "./AutorizacionComercioAsociadoRespuesta.vue?vue&type=script&lang=js&"
import style0 from "./AutorizacionComercioAsociadoRespuesta.vue?vue&type=style&index=0&id=56f0310a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f0310a",
  null
  
)

export default component.exports